import { em, math } from 'polished'
import styled, { css } from 'styled-components'

import Icon from 'components/Icon'
import { TextUpper } from 'styles/components/typography'

const markerFontSize = em(17)
const arrowIndent = em(15)
const arrowWidth = math(`${em(40)} + ${arrowIndent}`)

export const Li = styled.li`
  display: block;

  &:not(:last-child) {
    margin-bottom: ${em(20)};
  }

  ${({ isActive }) =>
    isActive &&
    css`
      ${p => p.theme.mq.upMd} {
        ${Description}, ${IconStyled} {
          opacity: 1;
        }
        ${Bullet} {
          opacity: 0;
        }

        ${IconStyled} {
          transition-delay: ${p => p.theme.animation.timeLonger};
        }
      }
    `}

  ${({ noHover }) =>
    !noHover &&
    css`
      ${p => p.theme.mq.hover} {
        ${p => p.theme.mq.upMd} {
          cursor: pointer;
        }
      }
    `}
`

export const Inner = styled.div`
  position: relative;
  transition: transform ${p => p.theme.animation.timeBtns};
`

export const Bullet = styled.div`
  display: inline-block;
  position: absolute;
  top: 0;
  border-radius: 50%;
  font-size: ${markerFontSize};
  padding-right: ${em(10)};
  // Strange x-value because we want to make it looks like ListItem element
  transform: translate(-80%, -5%);
  transition: opacity ${p => p.theme.animation.timeBtns} linear;
  transition-delay: ${p => p.theme.animation.timeBtns};
  -webkit-backface-visibility: hidden;
  pointer-events: none;
  color: ${p => p.bulletColor};
`

export const TitleWrapper = styled.div`
  position: relative;
  display: inline-block;
`

export const Description = styled.div`
  opacity: ${p => p.theme.blocks.blockMutedOpacity};
  transition: opacity ${p => p.theme.animation.timeBtns};

  ${p => p.theme.mq.hover} {
    ${p => p.theme.mq.upMd} {
      &:hover {
        opacity: 1;
      }
    }
  }
`

export const IconStyled = styled(Icon)`
  width: ${arrowWidth};
  height: ${em(10)};
  opacity: 0;
  transition: opacity ${p => p.theme.animation.timeBtns};
  top: ${em(10)};

  ${p => p.theme.mq.upMd} {
    display: none;
  }

  ${p => p.theme.mq.upLg} {
    display: inline-block;
  }

  ${({ arrowPosition }) =>
    arrowPosition === 'left' &&
    css`
      width: ${arrowWidth};
      left: -${arrowWidth};
      padding-right: ${arrowIndent};
      position: absolute;
    `}

  ${({ arrowPosition }) =>
    arrowPosition === 'right' &&
    css`
      padding-left: ${arrowIndent};
    `}
`

export const TextUpperStyled = styled(TextUpper)`
  white-space: normal;
`

export const TextWrapper = styled.p`
  white-space: nowrap;
`
